import { useRouter } from 'next/router';

export const useIsHideLayout = () => {
  const router = useRouter();

  return router.query.hideLayout === 'true';
};
